import styled from 'styled-components';

export const Container = styled.main`
  display: flex;
  flex-direction: row;
  gap: 32px;
  flex: 1;
  min-height: 100vh;
  max-width: 1194px;
  background-color: gray;
  margin: 0 24px;
  background-color: #ffffff;
`;
